import { Component, OnInit, OnDestroy, ElementRef, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ZIndexMngr } from '@core_n/common/ZIndexMngr';
import { SensorObject } from '../asp/SensorObject';
import { SensorBias, SensorBiasMngr } from './sensor-bias';
import { UserActionService } from '@core_n/user-action/user-action.service';
import * as units from '@core_n/common/units';
import * as utils from '@core_n/common/utils';
import * as consts from '@core_n/common/consts';
import * as projMsgs from '../msg/projMsgs';
import * as projEnums from '../common/projEnums';

const EMPTY_VALUE: string = '---';

@Component({
  selector: 'app-sensor-bias',
  templateUrl: './sensor-bias.component.html',
  styleUrls: ['./sensor-bias.component.scss']
})
export class SensorBiasComponent extends ZIndexMngr implements OnInit, OnDestroy {

  sensorTitle: string;
  range: string;
  rangeAcc: string;
  rangeRegistered: boolean;
  azimuth: string;
  azimuthAcc: string;
  azimuthRegistered: boolean;
  elevation: string;
  elevationAcc: string;
  elevationRegistered: boolean;
  location: string;
  altitude: string;
  locationRegistered: boolean;
  wellLocated: boolean;

  private sensor: SensorObject = null;
  private sensorBias: SensorBias = null;

  constructor(public dialogRef: MatDialogRef<SensorBiasComponent>,
              private userActionSrv: UserActionService,
              elementRef: ElementRef,
              @Inject(MAT_DIALOG_DATA) data: any) {
    super(elementRef);
    this.setSensor(data.sensor);

    let _this = this;
    setInterval(function () { _this.periodicUpdate() }, consts.DIALOG_REFRESH_INTERVAL);
  }

  static createDialogConfig(sensor: SensorObject) {
    let dialogConfig = utils.createDialogConfig(false);
    dialogConfig.data = { sensor: sensor };
    return dialogConfig;
  }
  
  setSensor(sensor: SensorObject) {
    this.sensor = sensor;
    this.periodicUpdate();
  }

  ngOnInit() {
    this.dialogRaise();
  }

  ngOnDestroy(): void {
    this.dialogClosed();
  }

  private periodicUpdate() {
    if (!this.sensor) {
      this.dialogRef.close();
      return;
    }
    if (!this.sensor.active()) {
      this.sensor = null;
      this.dialogRef.close();
      return;
    }

    this.sensorBias = SensorBiasMngr.getSelf().getSensorBias(this.sensor.sensorID);

    this.sensorTitle = this.sensor.getTitle();
    this.range = this.sensorBias && this.sensorBias.range != undefined ?
      `${this.sensorBias.range.toFixed(1)}m` : EMPTY_VALUE;
    this.rangeAcc = this.sensorBias && this.sensorBias.rangeAccuracy != undefined ?
      `${this.sensorBias.rangeAccuracy.toFixed(1)}m` : EMPTY_VALUE;
    this.rangeRegistered = this.sensorBias && this.sensorBias.isRangeRegistered;
    this.azimuth = this.sensorBias && this.sensorBias.azimuth != undefined ?
      `${(this.sensorBias.azimuth * units.RAD_TO_DEG).toFixed(2)}${units.DEGREE_CHAR}` : EMPTY_VALUE;
    this.azimuthAcc = this.sensorBias && this.sensorBias.azimuthAccuracy != undefined ?
      `${(this.sensorBias.azimuthAccuracy * units.RAD_TO_DEG).toFixed(2)}${units.DEGREE_CHAR}` : EMPTY_VALUE;
    this.azimuthRegistered = this.sensorBias && this.sensorBias.isAzimuthRegistered;
    this.elevation = this.sensorBias && this.sensorBias.elevation != undefined ?
      `${(this.sensorBias.elevation * units.RAD_TO_DEG).toFixed(2)}${units.DEGREE_CHAR}` : EMPTY_VALUE;
    this.elevationAcc = this.sensorBias && this.sensorBias.elevationAccuracy != undefined ?
      `${(this.sensorBias.elevationAccuracy * units.RAD_TO_DEG).toFixed(2)}${units.DEGREE_CHAR}` : EMPTY_VALUE;
    this.elevationRegistered = this.sensorBias && this.sensorBias.isElevationRegistered;

    let loc = this.sensorBias && this.sensorBias.shifting ? this.sensorBias.shifting : null;
    this.location = loc ? utils.getCoordinatesString({ x: loc.longitude, y: loc.latitude }, undefined, true) : EMPTY_VALUE;
    this.altitude = loc ? `${loc.altitude.toFixed(1)}m` : EMPTY_VALUE;
    this.locationRegistered = this.sensorBias && this.sensorBias.isLocationRegistered;
    this.wellLocated = this.sensorBias && this.sensorBias.isWellLocated;
  }

  resetBiases() {
    let resetBiasesMsg = new projMsgs.ResetBiasesMsg();
    resetBiasesMsg.systemId = this.sensor.sensorID;
    resetBiasesMsg.source = projEnums.FieldSource.Menatev;
    this.userActionSrv.sendUserAction(resetBiasesMsg);
  }

  unregister() {
    let unregisterMsg = new projMsgs.UnregisterMsg();
    unregisterMsg.systemId = this.sensor.sensorID;
    unregisterMsg.source = projEnums.FieldSource.Menatev;
    this.userActionSrv.sendUserAction(unregisterMsg);
  }
}
